const CATEGORY_SEARCH_TOKEN_ALIASES: Record<string, string> = {
  men: "men",
  mens: "men",
  women: "women",
  womens: "women",
};

const normalizeCategorySearchToken = (token: string): string =>
  CATEGORY_SEARCH_TOKEN_ALIASES[token] ?? token;

const toSearchTokens = (value: string): string[] =>
  (
    value
      .toLowerCase()
      .normalize("NFKD")
      .replace(/\p{M}/gu, "")
      .replace(/[’']/g, "")
      .match(/[\p{L}\p{N}]+/gu) ?? []
  ).map(normalizeCategorySearchToken);

export const splitCategoryNames = (value: string): string[] =>
  value
    .split(/[;,|]/)
    .map((category) => category.trim())
    .filter(Boolean);

/**
 * Matches category names using either the existing substring search or whole
 * normalized terms. Whole-term mode keeps gender category aliases such as
 * "men's" and "mens" together without matching "women's".
 */
export const matchesCategorySearch = (
  value: string,
  query: string,
  matchWholeWords: boolean,
): boolean => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return true;
  }

  if (!matchWholeWords) {
    return value.toLowerCase().includes(normalizedQuery);
  }

  const valueTokens = toSearchTokens(value);
  return toSearchTokens(normalizedQuery).every((queryToken) => valueTokens.includes(queryToken));
};
